import GlobalLoader from "@/components/Loading/GlobalLoader"
import ProductCard from "./ProductCard"
import styles from "./product-grid.module.css"

export default function ProductGrid({ searchTerm, products, onRemoveProduct, onUpdateProduct, isLoading }) {
  const filteredProducts = products.filter((product) => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase())
    return matchesSearch
  })

  return (
    <div className={styles.productGridSection}>
      <div className={styles.resultsHeader}>
        <h2 className={styles.resultsTitle}>{filteredProducts.length} Products Found</h2>
      </div>

      {isLoading && (
        <div className={styles.noResults}>
          <GlobalLoader
            isLoading
            variant="spinner"
            message="Preparing fresh products"
          />
        </div>
      )}

      {!isLoading && filteredProducts.length > 0 && (
        <div className={styles.productGrid}>
          {filteredProducts.map((product) => (
            <ProductCard key={product._id} product={product} onRemove={onRemoveProduct} onUpdate={onUpdateProduct} />
          ))}
        </div>
      )}
      
      {!isLoading && filteredProducts.length === 0 && (
        <div className={styles.noResults}>
          <p className={styles.noResultsText}>No products found. Try adjusting your filters.</p>
        </div>
      )}
    </div>
  )
}
